module.exports = __webpack_public_path__ + "scenarioAnalysis.d8126e81aa0f0ce1023aba246fcd44d0.png";